import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { LocalizationPipe } from './localization.pipe';


@Pipe({ name: 'recipeBadge' })
export class RecipeBadgePipe implements PipeTransform {

    constructor(
        @Inject(forwardRef(() => LocalizationPipe)) private localizationPipe: LocalizationPipe
    ) { }

    transform(type: RecipeBadgeType): any {
        if (type == RecipeBadgeType.NONE) {
            return '';
        }
        const style = this.getStyle(type);
        const icon = this.getIcon(type);
        const iconColor = this.getIconColor(type);
        const value = this.localizationPipe.transform(type == RecipeBadgeType.SHARED ? 'SHARED' : 'READ ONLY');
        return `<div class="sm-status-badge" style="${style}">
                    <span class="material-symbols-outlined sm-status-badge-icon" style="color: ${iconColor}">${icon}</span>     
                    ${value}
                </div>`;
    }

    private getStyle(type: RecipeBadgeType): string {
        if (type == RecipeBadgeType.SHARED) {
            return "color: #07570E;background-color: #0EAE1C26;";
        } else {
            return "color: #212121;background-color: #42424226;";
        }
    }

    private getIcon(type: RecipeBadgeType): string {
        if (type == RecipeBadgeType.SHARED) {
            return "share";
        } else {
            return "lock";
        }
    }

    private getIconColor(type: RecipeBadgeType): string {
        if (type == RecipeBadgeType.SHARED) {
            return "#0EAE1C";
        } else {
            return "#424242";
        }
    }
}

export enum RecipeBadgeType {
    NONE = "NONE",
    SHARED = "SHARED",
    READ_ONLY = "READ_ONLY"
}